import React from 'react';
import { FadeIn } from './FadeIn';
import { MessageCircleIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-32 bg-petrol relative border-y border-turquoise/20 overflow-hidden" data-id="element-38">
      {/* Techy radial gradient background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-turquoise/5 rounded-full blur-[150px] pointer-events-none" data-id="element-39"></div>

      {/* Circuit overlay */}
      <div className="absolute inset-0 bg-circuit opacity-30 pointer-events-none" data-id="element-40"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-41">
        <FadeIn data-id="element-42">
          <h2 className="text-5xl md:text-7xl font-bold mb-8 leading-tight" data-id="element-43">
            ¿Listo para que su clínica sea la opción{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-turquoise to-turquoise-light italic" style={{
            paddingBottom: '0.1em',
            display: 'inline-block'
          }} data-id="element-44">
              #1 en Google?
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-silver-light mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-45">
            Agende una auditoría gratuita de 15 minutos y descubra cómo atraer
            pacientes de alto valor a su consultorio.
          </p>

          <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-turquoise hover:bg-turquoise-hover text-petrol font-bold text-lg px-10 py-5 rounded-lg transition-all hover:shadow-[0_0_30px_rgba(0,212,170,0.4)] hover:-translate-y-1" data-id="element-46">
            <MessageCircleIcon className="w-6 h-6" data-id="element-47" />
            SOLICITAR AUDITORÍA GRATUITA
          </a>
        </FadeIn>
      </div>
    </section>;
}